/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots3HCircleIcon16Light = forwardRef('UiMenuDots3HCircleIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11 8.901A.901.901 0 1 0 11 7.1a.901.901 0 0 0 0 1.802Z" }),
        React.createElement("path", { d: "M8.901 8A.901.901 0 1 1 7.1 8 .901.901 0 0 1 8.9 8Z" }),
        React.createElement("path", { d: "M5 8.901A.901.901 0 1 0 5 7.1a.901.901 0 0 0 0 1.802Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1.004a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm-6 7a6 6 0 1 1 12 0 6 6 0 0 1-12 0Z" })));
});
